import { render, staticRenderFns } from "./OmsDrag.vue?vue&type=template&id=f0618b64&scoped=true"
import script from "./OmsDrag.vue?vue&type=script&lang=js"
export * from "./OmsDrag.vue?vue&type=script&lang=js"
import style0 from "./OmsDrag.vue?vue&type=style&index=0&id=f0618b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0618b64",
  null
  
)

export default component.exports